// extracted by mini-css-extract-plugin
module.exports = {"box":"Loader_box__XZ2hR"};